import { createRouter, createWebHashHistory, RouteRecordRaw, RouteLocationNormalized } from 'vue-router'
import TopView from '@/views/TopView.vue'
import ReportsView from '@/views/ReportsView.vue'
import AlertsHistory from '@/views/Alerts/AlertsHistory.vue'
import AlertsCurrent from '@/views/Alerts/AlertsCurrent.vue'
import ThreasholdHistory from '@/views/Alerts/ThreasholdHistory.vue'
import RainDetail from '@/views/RainDetail.vue'
import WaterDetail from '@/views/WaterDetail.vue'
import WeatherDetail from '@/views/WeatherDetail.vue'
import CameraView from '@/views/CameraView.vue'
import WeatherView from '@/views/WeatherView.vue'
import SpMenuView from '@/views/SpMenuView.vue'
import GraphView from '@/views/GraphView.vue'
import LinkView from '@/views/LinkView.vue'
import SoilChartView from '@/views/SoilChart.vue'
import DataDownloadView from '@/views/DataDownload.vue'
import Settings from '@/views/Settings'
import { useInitDataStore } from '@/stores/initDataStore'
import { useGlobalStore } from '@/stores/globalStore'

const routes: Array<RouteRecordRaw> = [
  // TOP
  {
    path: '/top/:viewType',
    name: '現在データ',
    component: TopView,
  },

  // 帳票
  {
    path: '/reports',
    name: '帳票',
    component: ReportsView,
  },

  // 閾値超過履歴
  {
    path: '/alerts/threashold',
    name: '閾値超過履歴',
    component: ThreasholdHistory,
  },

  // 注意報警報履歴(気象庁)(実況)(alias)
  {
    path: '/alerts/jma',
    name: '注意報警報履歴(気象庁)(実況) ',
    component: AlertsCurrent,
  },

  // 注意報警報履歴(気象庁)(実況)
  {
    path: '/alerts',
    name: '注意報警報履歴(気象庁)(実況)',
    component: AlertsCurrent,
  },

  // 注意報警報履歴(気象庁)(履歴)
  {
    path: '/alerts/history',
    name: '注意報警報履歴(気象庁)(履歴)',
    component: AlertsHistory,
  },

  // 雨量詳細
  {
    path: '/rain_detail/:stationId',
    name: '雨量詳細',
    component: RainDetail,
    meta: {
      showStatoinSelect: true,
      stationType: 'rain',
    },
  },

  // 水位詳細
  {
    path: '/water_detail/:stationId',
    name: '水位詳細',
    component: WaterDetail,
    meta: {
      showStatoinSelect: true,
      stationType: 'water',
    },
  },

  // 気象詳細
  {
    path: '/weather_detail/:stationId',
    name: '気象詳細',
    component: WeatherDetail,
    meta: {
      showStatoinSelect: true,
      stationType: 'weather',
    },
  },

  // カメラ一覧
  {
    path: '/camera',
    name: 'カメラ',
    component: CameraView,
  },

  // 天気予報
  {
    path: '/weather',
    name: '天気予報',
    component: WeatherView,
  },

  // グラフ
  {
    path: '/graph',
    name: 'グラフ',
    component: GraphView,
  },

  // 関連リンク
  {
    path: '/link',
    name: 'リンク',
    component: LinkView,
  },

  // 土壌雨量指数表
  {
    path: '/soil',
    name: '土壌雨量指数表',
    component: SoilChartView,
  },

  // 過去データダウンロード
  {
    path: '/data_download',
    name: '過去データダウンロード',
    component: DataDownloadView,
  },

  // SP用メニュー
  {
    path: '/menu',
    name: 'メニュー',
    component: SpMenuView,
  },

  // お知らせ設定編集
  {
    path: '/settings/information/edit/:id?',
    name: 'お知らせ設定編集',
    component: Settings.Information.Edit,
  },

  // お知らせ設定
  {
    path: '/settings/information',
    name: 'お知らせ設定',
    component: Settings.Information.Index,
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

export const setTitle = (route: RouteLocationNormalized) => {
  const initDataStore = useInitDataStore()
  const title = initDataStore.initData.systemInfo.title

  window.document.title = `${title} ${route.name?.toString()}`
}

const setDefaultPage = (route: RouteLocationNormalized) => {
  const initDataStore = useInitDataStore()

  if (route.path === '/' && initDataStore.initData.systemInfo.defaultPage) {
    router.replace(initDataStore.initData.systemInfo.defaultPage)
  }
}

router.beforeEach(to => {
  setTitle(to)
  setDefaultPage(to)
  useGlobalStore().startAutoUpdate()
})

export default router
